export const state = {
  modals: {
    cartItemRemove:     null,
    cartItemEdit:       null,
    cartItemAdd:        null,
    cartOrderCancel:    null,
    goToMenuOrMain:     false,
    checkoutModal:      false,
    guestCheckoutModal: false,
  },
  apiError: {},
};

export const getters = {
  modalInfo: state => modalName => state.modals[modalName],
  /**
   * Check mobile platform.
   */
  isMobilePlatform() {
    return process.env.PLATFORM === 'mobile';
  },
  /**
   * Check kiosk platform.
   */
  isKioskPlatform() {
    return process.env.PLATFORM === 'kiosk';
  },
  /**
   * Check web platform.
   */
  isWebPlatform() {
    return process.env.PLATFORM === 'web';
  },
  apiError: state => state.apiError || {},
};

export default {
  state,
  getters,
};



// WEBPACK FOOTER //
// ./src/apps/core/store/state.js